<template>
  <div style="width: 100%; height: auto; padding-top: 3vh; padding-bottom: 3vh">
    <span>
      <router-link to="/">Home </router-link>
    </span>
    <span>
      <router-link to="/readPaper">Read Papers </router-link>
    </span>
    <span>
      <router-link to="/game">Games </router-link>
    </span>
    <span>
      <router-link to="/photo">Photos </router-link>
    </span>
    <span>
      <router-link to="/chinese">中文学习</router-link>
    </span>
  </div>
</template>

<style scoped>
span {
  padding-left: 30px;
  padding-right: 30px;
}
</style>
